<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__sluser}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:sluser:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:sluser:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userName" label="用户名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="realName" label="真实姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pwd" label="登陆密码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="webchatCode" label="微信号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="webchatName" label="微信昵称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="email" label="电子邮件" header-align="center" align="center"></el-table-column>
        <el-table-column prop="vipLevelId" label="会员类型" header-align="center" align="center">
          <template slot-scope="scope">
            {{ geteducation(scope.row.vipLevelId,'vipLevelId') }}
          </template>
        </el-table-column>
        <el-table-column prop="vipLevelName" label="会员名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="mobilePhone" label="手机号码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cardId" label="证件ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deptId" label="部门ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sex" label="性别" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.sex == '0' ? '女' : '男'}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.status == '0' ? '解锁' : '锁定'}}
          </template>
        </el-table-column>
        <el-table-column prop="userType" label="用户类型" header-align="center" align="center">
          <template slot-scope="scope">
            {{ geteducation(scope.row.userType,'userType') }}
          </template>
        </el-table-column>
        <el-table-column prop="headStatus" label="头像" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.headStatus == '0' ? '默认' : '自定义'}}
          </template>
        </el-table-column>
        <el-table-column prop="headIco" label="头像URL" width="200px" header-align="center" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="birthday" label="出生年月日" header-align="center" align="center"></el-table-column>
        <el-table-column prop="education" label="学历" header-align="center" align="center">
          <!-- 1：小学；2：初中；3：高中；4：中专；5：大专；6：本科；7：硕士；8：博士；9其他 -->
          <template slot-scope="scope">
            {{ geteducation(scope.row.education,'education') }}
          </template>
        </el-table-column>
        <el-table-column prop="maritalStatus" label="婚姻状况 " header-align="center" align="center">
          <!-- 0:未婚；1：已婚；2：离异；3：丧偶 -->
          <template slot-scope="scope">
            {{ geteducation(scope.row.maritalStatus,'maritalStatus') }}
          </template>
        </el-table-column>
        <el-table-column prop="province" label="户籍所在省" header-align="center" align="center"></el-table-column>
        <el-table-column prop="city" label="户籍所在市" header-align="center" align="center"></el-table-column>
        <el-table-column prop="address" label="地址" header-align="center" align="center"></el-table-column>
        <el-table-column prop="workExperience" label="工作年限" header-align="center" align="center">

        </el-table-column>
        <el-table-column prop="loginTime" label="最后登录时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pwdModifyTime" label="密码修改时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="inviteUserId" label="邀请人ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isAuth" label="状态" header-align="center" align="center">
          <!-- 0:未认证 1:认证成功，2：认证失败 -->
          <template slot-scope="scope">
            {{ geteducation(scope.row.isAuth,'isAuth') }}
          </template>
        </el-table-column>
        <el-table-column prop="authApplyTime" label="认证申请日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="authTime" label="认证通过日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="openId" label="微信唯一标识符" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:sluser:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:sluser:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './sluser-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/sluser/page',
        getDataListIsPage: true,
        exportURL: '/sys/sluser/export',
        deleteURL: '/sys/sluser',
        deleteIsBatch: true
      },
      educations: [],
      userTypes: [],
      vipLevels: [],
      maritalStatus: [],
      isAuth: [],
      dataForm: {
        id: ''
      }
    }
  },
  mounted() {
    this.geteducationOptions()
    this.getuserTypeOptions()
    this.getvipLevelOptions()
    this.getmaritalStatusOptions()
    this.getworkExperienceOptions()
    this.getisAuthOptions()
  },
  methods:{
    geteducation(v,name){
      if(name == 'userType'){
        console.log(this.userTypes)
        return this.userTypes.filter(item => item.value == v)[0]?.label
      }
      // maritalStatus
      if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
      if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
      if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
      if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
      
    },
     //初始认证下拉框中的选项
     async getisAuthOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=isAuth`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.isAuth = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.isAuth.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
     //初始工作年限下拉框中的选项
     async getworkExperienceOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=workExperience`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.workExperience = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.workExperience.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
       //初始婚姻下拉框中的选项
       async getmaritalStatusOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=maritalStatus`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.maritalStatus=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.maritalStatus.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    
     //初始会员下拉框中的选项
     async getvipLevelOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=vipLevel`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.vipLevels=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.vipLevels.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      //初始用户类型名称下拉框中的选项
      async getuserTypeOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=userType`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.userTypes = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.userTypes.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
  
  
           //初始学历名称下拉框中的选项
           async geteducationOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=education`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.educations = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.educations.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
  },
  components: {
    AddOrUpdate
  }
}
</script>
